module.exports = __webpack_public_path__ + "static/media/VOCAB-02.f89d66e9.png";